export const ServiceWorkerRegistration = {
  register: () => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/service-worker.js')
          .then((registration) => {
            console.info('[ServiceWorker]: Registered with scope: ', registration.scope);
          })
          .catch((error) => {
            console.error('[ServiceWorker]: Registration failed:', error);
          });
      });
    }
  },

  unregister: () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.unregister();
      });
    }
  }
};
